(function() {
    'use strict';

    angular
        .module('ResourceGenerator')
        .factory('AbstractModelService', AbstractModelService);

    function AbstractModelService(lodash) {
        var crud_actions = {
            'query'  : {
                method: 'GET',
                isArray:false,
                params: {
                    search: '@search',
                    page: '@page',
                    size: '@size',
                    sort: '@sort'
                },
                cancellable: true
            },
            'search'  : {
                method: 'POST',
                isArray:false
            },
            'get'    : { method: 'GET', cancellable: true},
            'create' : { method: 'POST' },
            'post' : { method: 'POST' },
            'patch'  : { method: 'PATCH' },
            'update' : { method: 'PUT' },
            'delete' : { method: 'DELETE'},
            'getArray'    : { method: 'GET', isArray: true }
        };

        /**
         * AbstractModelService generates actions of resources base on "option" object. See below for example data.
         */
        /*
         {
         basePath: '', // required
         defaultActions: ['query', 'get', 'patch'], // optional. If not defined, use all.
         levels: [
         {
         path: 'relationships', // required
         param: ':relationshipId', // required
         suffix: 'relationship', // if not specify, use path,
         actions: ['query', 'get'] // if not defined, use all
         }
         ]
         };
         */
        return function(options) {
            var actions = angular.copy(crud_actions);

            // if not options object provided, return the basic CRUD Actions
            if (!options) {
                return actions;
            }

            // If DefaultActions field is detected, remove those not needed.
            if (lodash.has(options, 'defaultActions')) {
                //for (var action in actions) {
                //    if (options,defaultActions.indexOf(action) < 0) {
                //        delete(actions[action]);
                //    }
                //}
                angular.forEach(options.defaultActions, function(option, index) {
                    var action = lodash.get(actions, index, false);
                    if (!action) {
                        actions.delete(actions[index]);
                    }
                });
                actions = angular.merge(actions, options.defaultActions);
            }

            // If Levels is required, go through the levels to generate the actions
            if (lodash.has(options, 'levels')) {
                angular.forEach(options.levels, function(level) {

                    // prepare of data for the level
                    var tempActions = angular.copy(crud_actions);
                    var levelActions = {};

                    // generate all actions
                    for (var action in tempActions) {
                        var path = options.basePath + "/" + angular.copy(level.path);
                        if (['query','create'].indexOf(action) < 0) {
                            path += '/' + level.param;
                        }

                        //
                        var actionNameSuffix = level.suffix || level.path;
                        actionNameSuffix = actionNameSuffix.charAt(0).toUpperCase() + actionNameSuffix.substr(1);

                        var prefix = (action == 'create') ? 'add' : action;

                        levelActions[prefix + actionNameSuffix] = angular.merge(tempActions[action], {
                            url: path
                        });
                    }

                    // if have actions field, remove those not needed
                    if (lodash.has(level,'actions')) {
                        for (var levelAction in levelActions) {
                            if (level.actions.indexOf(levelAction) < 0) {
                                delete(levelActions[levelAction]);
                            }
                        }
                    }

                    // Merge the generated actions back to the return result
                    actions = angular.merge(actions, levelActions);
                });
            }
            return actions;
        };
    }
})();

